import React from "react";

import SoccerIcon from "../../../images/football.webp";
import EsportsIcon from "../../../images/esports.webp";
import BasketballIcon from "../../../images/basketball.webp";
import HockeyIcon from "../../../images/ice-hockey.webp";
import VolleyballIcon from "../../../images/volleyball.webp";
import HandballIcon from "../../../images/handball.webp";
import FutsalIcon from "../../../images/futsal.webp";
import DartsIcon from "../../../images/darts.webp";
import WaterpoloIcon from "../../../images/waterpolo.webp";

const iconMap = {
  Soccer: SoccerIcon,
  eSports: EsportsIcon,
  Basketball: BasketballIcon,
  "Ice Hockey": HockeyIcon,
  Volleyball: VolleyballIcon,
  Handball: HandballIcon,
  Futsal: FutsalIcon,
  Darts: DartsIcon,
  Waterpolo: WaterpoloIcon,
};

const SportFilter = ({ isDarkMode, selectedSport, setSelectedSport }) => {
  const sportsData = [
    { name: "Soccer", count: 135 },
    { name: "eSports", count: 27 },
    { name: "Basketball", count: 45 },
    { name: "Ice Hockey", count: 41 },
    { name: "Volleyball", count: 35 },
    { name: "Handball", count: 31 },
    { name: "Futsal", count: 13 },
    { name: "Darts", count: 8 },
    // { name: "Darts", count: 8 },
    { name: "Waterpolo", count: 8 },
  ];

  const handleSportSelect = (sport) => {
    setSelectedSport(sport.name === selectedSport ? null : sport.name);
  };

  return (
    <div className="max-sm:p-[15px_0_15px_20px] p-[12px_0_12px_20px] s18:p-[22px_0_22px_20px]">
      <ul className="flex max-sm:gap-[15px] sm:gap-[23px] overflow-auto min-h-[40px]">
        {sportsData.map((sport, index) => {
          const Icon = iconMap[sport.name];
          const isSelected = selectedSport === sport.name;

          return (
            <li
              key={index}
              onClick={() => handleSportSelect(sport)}
              className={`cursor-pointer flex items-center whitespace-nowrap gap-2 px-2 py-1 rounded transition-colors duration-300
                ${
                  isSelected
                    ? "text-darkblue dark:text-yellow"
                    : "text-mutedblue dark:text-white"
                }
                hover:text-darkblue dark:hover:text-yellow
                `}
              style={{ userSelect: "none" }}
              aria-pressed={isSelected}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleSportSelect(sport);
                }
              }}
            >
              <div className="relative flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6">
                {Icon && (
                  <img
                    src={Icon}
                    alt={`${sport.name} icon`}
                    className="w-full h-full object-contain"
                    draggable={false}
                  />
                )}
                <span
                  className="absolute -top-1 -right-2 min-w-[18px] h-[18px] rounded-full bg-yellow text-white text-[10px] font-semibold flex items-center justify-center leading-none shadow-md select-none"
                  aria-label={`${sport.count} items`}
                >
                  {sport.count}
                </span>
              </div>
              <span className="text-sm s18:text-base font-normal leading-[1.43]">
                {sport.name}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SportFilter;
